import { Controller } from 'stimulus';
import loadSlick from '../helpers/loadSlick';

class ReviewsSliderController extends Controller {
  connect() {
    this.$element = $(this.element);
    this.$slider = $(this.sliderTarget);
    this.$prev = this.$element.find('.js-reviews-slider-prev');
    this.$next = this.$element.find('.js-reviews-slider-next');
    this.$arrows = this.$element.find('.js-reviews-slider-arrows');

    loadSlick().then(() => {
      this.create();
    });
  }

  disconnect() {
    this.$slider.slick('unslick');
  }

  create() {
    this.$prev.on('click', () => {
      this.$slider.slick('slickPrev');
    });

    this.$next.on('click', () => {
      this.$slider.slick('slickNext');
    });

    const config = {
      rows: 0,
      fade: true,
      arrows: false,
      mobileFirst: true,
      autoplay: true,
      autoplaySpeed: 5000,
      adaptiveHeight: true,
      cssEase: 'cubic-bezier(.455, .03, .515, .955)',
    };

    this.$slider.on('init', (e, slick) => {
      const $slideHeight = $(slick.$slides[0]).innerHeight();

      this.changeArrowPositions($slideHeight);
    });

    this.$slider.slick(config);

    this.$slider.on('beforeChange', (e, slick, currentSlide, nextSlide) => {
      const $slideHeight = $(slick.$slides[nextSlide]).innerHeight();

      this.changeArrowPositions($slideHeight);
    });
  }

  changeArrowPositions(slideHeight) {
    this.$arrows.css({
      opacity: 1,
      visibility: 'visible',
      transform: `translateY(${slideHeight}px)`,
    });
  }
}

ReviewsSliderController.targets = [
  'slider',
];

export default ReviewsSliderController;
